import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, MapPin, Users } from 'lucide-react';
import useCrousLive from '../../hooks/useCrousLive';
import { useEstablishmentAuth } from '../../context/EstablishmentAuthContext';
import CrousLiveBadge from './components/CrousLiveBadge';
import OverridePanel from './components/OverridePanel';
import MenuPanel from './components/MenuPanel';
import WaitTimePanel from './components/WaitTimePanel';
import StatsPanel from './components/StatsPanel';
import PredictionPanel from './components/PredictionPanel';
import './establishment.css';

function CrousDetailPage() {
  const { crousId } = useParams();
  const { adminDoc } = useEstablishmentAuth();
  const { data, loading, pings } = useCrousLive(crousId);

  const canManage =
    adminDoc &&
    (adminDoc.role === 'super' ||
      (adminDoc.role === 'establishment' &&
        adminDoc.crousIds &&
        adminDoc.crousIds[crousId] === true));

  if (loading) {
    return <div className="est-empty">Chargement du RU…</div>;
  }

  if (!data) {
    return (
      <div className="est-empty">
        RU introuvable. <Link to="/etablissement/gestion">Retour au dashboard</Link>
      </div>
    );
  }

  if (!canManage) {
    return (
      <div className="est-empty">
        Ce RU n'est pas rattaché à ton compte. <Link to="/etablissement/gestion">Retour</Link>
      </div>
    );
  }

  return (
    <div className="est-page">
      <div className="est-breadcrumb">
        <Link to="/etablissement/gestion">
          <ArrowLeft size={16} /> Tous les RU
        </Link>
      </div>

      <div className="est-page-head">
        <div>
          <span className="est-kicker">Restaurant universitaire</span>
          <h1>{data.name || crousId}</h1>
          <div className="est-ru-meta">
            {data.campus && (
              <span>
                <MapPin size={14} /> {data.campus}
              </span>
            )}
            {data.capacity && (
              <span>
                <Users size={14} /> Capacité {data.capacity}
              </span>
            )}
            <span>
              {pings.length} signalement{pings.length > 1 ? 's' : ''} / 15 min
            </span>
          </div>
        </div>
        <CrousLiveBadge crousId={crousId} />
      </div>

      <div className="est-grid">
        <OverridePanel crousId={crousId} currentOverride={data.adminOverride} />
        <MenuPanel crousId={crousId} />
        <WaitTimePanel crousId={crousId} />
        <StatsPanel crousId={crousId} />
        <PredictionPanel crousId={crousId} />
      </div>
    </div>
  );
}

export default CrousDetailPage;
